import { ShopSort, ShopFilter } from '@data/sanity/schema'
import { SanityColor } from './product'

export enum SanityFilterType {
  SIMPLE = ' ',
  SWATCH = 'swatch',
}

export enum SanityFilterGroupDisplay {
  DEFAULT = ' ',
  GRID = 'grid',
}

export interface SanityFilterGroupOption {
  slug: string
  type: SanityFilterType
  title: string
  color?: SanityColor
}

export interface SanityFilterGroup {
  _key: string
  slug: string
  display: SanityFilterGroupDisplay
  title: string
  options: SanityFilterGroupOption[]
}

export type SanityFilter = Pick<ShopFilter, 'isActive'> & {
  groups?: SanityFilterGroup[]
}

export enum SanitySortOptionType {
  FEATURED = 'featured',
  ALPHA_ASCENDING = 'alphaAsc',
  ALPHA_DESCENDING = 'alphaDesc',
  DATE_ASCENDING = 'dateAsc',
  DATE_DESCENDING = 'dateDesc',
  PRICE_ASCENDING = 'priceAsc',
  PRICE_DESCENDING = 'priceDesc',
}

export type SanitySortOption = {
  type: SanitySortOptionType
  title: string
}

export type SanitySort = Pick<ShopSort, 'isActive'> & {
  options?: SanitySortOption[]
}
